import { isJsonSerializable } from 'utils/isJsonSerializable'

export async function runWebWorker<WorkerReturnType>(
  worker: Worker,
  props: unknown
): Promise<WorkerReturnType> {
  if (!isJsonSerializable(props)) {
    throw new Error('worker props must be JSON serializable')
  }
  return new Promise((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<WorkerReturnType>) => {
      resolve(event.data)
      worker.terminate()
    }
    worker.onerror = (error) => {
      reject(error)
      worker.terminate()
    }
    worker.postMessage(props)
  })
}
